// "Save your progress": shown wherever a signed-out learner's progress lives
// only on their device (Today, and every lesson they finish). Signing in
// happens in a sheet, so they never lose their place.
import { html, raw } from '../lib/html.js';
import { icon } from '../lib/icons.js';
import { local } from '../lib/store.js';
import { syncState } from '../lib/sync.js';
import { openSignInSheet } from './signin-form.js';

export function signedIn() {
  return !!(syncState().user || local().user);
}

export function saveCard({ text = 'Your progress is only on this device. Sign in with your email to keep it safe and pick up on any phone or computer.', level = 2 } = {}) {
  if (signedIn()) return '';
  const H = raw(`h${level}`);
  return html`<section class="save-card" data-save-card data-level="${level}" aria-labelledby="save-card-title">
    <span class="save-card__icon" aria-hidden="true">${icon('cloud-off', { size: 22 })}</span>
    <div class="save-card__body">
      <${H} class="save-card__title" id="save-card-title">Save your progress</${H}>
      <p class="save-card__text">${text}</p>
    </div>
    <button type="button" class="btn btn--primary btn--small save-card__btn" data-save>${icon('mail', { size: 17 })} Sign in to save</button>
  </section>`;
}

export function bindSaveCard(root, { onSaved = () => {} } = {}) {
  const card = root.querySelector('[data-save-card]');
  if (!card) return;
  card.querySelector('[data-save]').addEventListener('click', async () => {
    const ok = await openSignInSheet();
    if (!ok || !card.isConnected) return;
    card.classList.add('save-card--done');
    const H = raw(`h${card.dataset.level || 2}`);
    card.innerHTML = String(html`<span class="save-card__icon" aria-hidden="true">${icon('check-circle', { size: 22 })}</span>
      <div class="save-card__body"><${H} class="save-card__title">Saved to your account</${H}>
      <p class="save-card__text">Your progress now syncs to every device where you sign in.</p></div>`);
    onSaved();
  });
}
